import { render, staticRenderFns } from "./VFileManger.vue?vue&type=template&id=37b4eecf&"
import script from "./VFileManger.vue?vue&type=script&lang=js&"
export * from "./VFileManger.vue?vue&type=script&lang=js&"
import style0 from "./VFileManger.vue?vue&type=style&index=0&id=37b4eecf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports